import { RoleType } from "../../../../../../Wrap/Constants/Enums/RoleType";
import { AccountRoleType } from "../../../../../../Wrap/Models/Domains/Customers/AccountRoleType";

const dataCaptureMatrix = {
    [RoleType.RegisteredContact]: ["Address", "DOB", "Phone"],
    [RoleType.Employer]: ["Address", "BankDetails"],
    [RoleType.ExSpouse]: ["Address", "DOB"],
    [RoleType.PowerOfAttorney]: ["Address", "DOB", "Phone", "Nationality"],
    [RoleType.LegalRepresentative]: ["Address", "DOB"],
    [RoleType.LetterOfAuthority]: ["Address"],
    [RoleType.Dependent]: ["Address", "DOB"],
    [RoleType.Nominee]: ["Address", "DOB"],
    [RoleType.ThirdPartyPayer]: ["Address", "BankDetails", "DOB"],
    [RoleType.TrustAppointer]: ["Address", "DOB"],
    [RoleType.TrustProtector]: ["Address", "DOB"],
    [RoleType.ControllingPerson]: ["Addresses", "DOB", "TaxNationality", "TOB", "COB"],
    [RoleType.DirectorController]: ["Address", "DOB"],
    [RoleType.ShareholderGT25]: ["Address", "DOB"],
    [RoleType.AdditionalSignatory]: ["Address", "DOB"],
    [RoleType.AccountAccess]: ["Address", "DOB"],
    [RoleType.LifeAssured]: ["Address"],
    [RoleType.AdditionalLifeAssured]: ["Address"],
};

const clientPortalAccessMatrix = [
    RoleType.RegisteredContact,
    RoleType.PowerOfAttorney,
    RoleType.LegalRepresentative,
    RoleType.Dependent,
    RoleType.Nominee,
];

export const isDisplay = (roleType: RoleType, section: string): boolean => {
    const roleMatrix = dataCaptureMatrix[roleType];
    if (roleMatrix == undefined) {return false;}
    const index = roleMatrix.findIndex((e) => e == section);
    return index < 0 ? false : true;
};

export const hasClientPortalAccess = (roleType: AccountRoleType): boolean => {
    return (
        roleType?.CustomerCategory == 1 &&
        roleType?.RoleType != RoleType.ShareholderGT25 &&
        roleType?.RoleType != RoleType.LetterOfAuthority &&
        roleType?.RoleType != RoleType.ThirdPartyPayer &&
        roleType?.RoleType != RoleType.Employer
    );
};
